import type { MaterialInput } from "./types.js";

export const DEFAULT_WASTE = 0.05;
export const DEFAULT_TILE_SIZE_M = 0.6;

const EPS = 1e-9;

/** ปัดขึ้นโดยกัน floating point เช่น 92.00000000001 */
export function ceilSafe(x: number): number {
  return Math.ceil(Math.round(x * 1e9) / 1e9 - EPS);
}

/** ปัดทศนิยม 2 ตำแหน่ง สำหรับปริมาณแบบต่อเนื่อง (ม., กก.) */
export function round2(x: number): number {
  return Math.round((x + Number.EPSILON) * 100) / 100;
}

function check(name: string, v: number | undefined, opts: { positive?: boolean } = {}): void {
  if (v === undefined) return;
  if (typeof v !== "number" || !Number.isFinite(v)) {
    throw new RangeError(`MaterialInput.${name} ต้องเป็นตัวเลขที่ถูกต้อง (ได้ ${String(v)})`);
  }
  if (v < 0 || (opts.positive && v === 0)) {
    throw new RangeError(`MaterialInput.${name} ต้องไม่ติดลบ${opts.positive ? "และมากกว่า 0" : ""} (ได้ ${v})`);
  }
}

export interface ResolvedInput {
  area: number;
  width?: number;
  length?: number;
  perimeter: number;
  waste: number;
  tileSizeM: number;
}

/** ตรวจ input แล้วเติมค่าที่คำนวณได้ throw RangeError ถ้าไม่ถูกต้อง */
export function resolveInput(input: MaterialInput): ResolvedInput {
  check("area", input.area);
  check("width", input.width);
  check("length", input.length);
  check("perimeter", input.perimeter);
  check("wastePct", input.wastePct);
  check("tileSizeM", input.tileSizeM, { positive: true });
  const { width, length } = input;
  const area = input.area ?? (width !== undefined && length !== undefined ? width * length : undefined);
  if (area === undefined) {
    throw new RangeError("MaterialInput ต้องระบุ area หรือ width และ length");
  }
  const perimeter =
    input.perimeter ?? (width !== undefined && length !== undefined ? 2 * (width + length) : undefined);
  return {
    area,
    width,
    length,
    perimeter: perimeter ?? NaN,
    waste: input.wastePct ?? DEFAULT_WASTE,
    tileSizeM: input.tileSizeM ?? DEFAULT_TILE_SIZE_M,
  };
}

/** เส้นรอบรูปที่ต้องใช้จริง ถ้าไม่มีให้ throw */
export function requirePerimeter(r: ResolvedInput): number {
  if (!Number.isFinite(r.perimeter)) {
    throw new RangeError("สูตรนี้ต้องระบุ perimeter หรือ width และ length");
  }
  return r.perimeter;
}
